import { render, staticRenderFns } from "./RequestDescriptionFilter.vue?vue&type=template&id=be59b758&"
import script from "./RequestDescriptionFilter.vue?vue&type=script&lang=js&"
export * from "./RequestDescriptionFilter.vue?vue&type=script&lang=js&"
import style0 from "./RequestDescriptionFilter.vue?vue&type=style&index=0&id=be59b758&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports